import React, { FC, useState } from 'react';
import IdentityInfo from '../IdentityInfo';
import {
  HeaderCell,
  iconButtonOverride,
  SearchButtonIcon,
  SingleSearchStyles,
} from './styles';
import { SearchExpandProps } from './types';
import { Search as SearchIcon } from '@octanner/prism-icons';
import { useIdentitySearch } from './identitySearch';
import { Identity } from './interfaces';
import { useTranslation } from 'react-i18next';
import Autocomplete from '../Autocomplete';
import { FullWidthTextField } from '../SingleSearch/styles';
import { CustomPaper, renderStartAdornment } from '../Search/styles';

const SearchExpand: FC<SearchExpandProps> = ({
  searchOpen,
  handleSearchOpen,
  routerObj: { routerPush, routerRoutes, testRoute },
}) => {
  const { t } = useTranslation();

  const [searchText, setSearchText] = useState('');
  const identitySearchQuery = useIdentitySearch(searchText);
  const searchOptions = identitySearchQuery?.data || [];

  const handleClose = () => {
    setSearchText('');
    handleSearchOpen(false);
  };

  const selectIdentity = (_: any, identity: Identity | string) => {
    if (typeof identity !== 'string') {
      const url = `/profile/${identity.identityUuid}`;
      if (routerPush && routerRoutes.some(testRoute(url))) {
        routerPush(url);
      } else {
        window.location.assign(url);
      }
    }
    handleClose();
  };

  if (!searchOpen) {
    return (
      <HeaderCell onFocus={() => handleSearchOpen(true)}>
        <SearchButtonIcon
          color="secondary"
          aria-label={t('prism-header:search-people', 'Search people')}
          onClick={() => handleSearchOpen(true)}
          sx={iconButtonOverride}
          data-testid="search-icon"
        >
          <SearchIcon color="secondary" />
        </SearchButtonIcon>
      </HeaderCell>
    );
  }
  return (
    <div
      onBlur={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget as Node)) {
          handleClose();
        }
      }}
    >
      <Autocomplete
        options={searchOptions}
        renderOption={(props, option) => (
          <li {...props}>
            <IdentityInfo identity={option} color="secondary" />
          </li>
        )}
        filterOptions={(options) => options}
        freeSolo
        onInputChange={(e, _, reason) => {
          if (reason === 'input') {
            setSearchText((e.target as HTMLInputElement).value);
          } else if (reason === 'clear') {
            handleClose();
          }
        }}
        onChange={(e, val) => {
          selectIdentity(e, val);
          handleClose();
        }}
        PaperComponent={CustomPaper}
        inputValue={searchText}
        sx={SingleSearchStyles}
        renderInput={(props) => (
          <FullWidthTextField
            placeholder={t('prism-header:search-people', 'Search people')}
            autoFocus={searchOpen}
            InputProps={{
              ...props.InputProps,
              startAdornment: renderStartAdornment(
                identitySearchQuery.loading,
                true,
                props.InputProps.startAdornment,
              ),
            }}
            inputProps={{
              ...props.inputProps,
              'data-testid': 'search-cc-header',
              onKeyDown: (e) => {
                if (e.key === 'Enter' && searchOptions?.length === 0) {
                  e.stopPropagation();
                }
              },
            }}
          />
        )}
      />
    </div>
  );
};

export default SearchExpand;
